
<template>
    <Modal v-model="isadjust" :styles="{width: '580px'}"  :mask-closable="false" footer-hide @on-visible-change="onvisiblechange">
        <div class="content">
          <div class="top">
            <div class="tit">{{parentData.tit}}</div>
            <p>{{parentData.roomName}}</p>  
              <div class="main-container clearAll">
                <div>
                <div class="z-div-1 z-ovhid">
                  <div class="z-div-1 piclist">
                    <img
                      v-for="(item,idx) in imgList"
                      :src="item.upadder"
                      alt="图片加载失败"
                      :key="item.upadder+idx"
                    />
                  </div>
                </div>
                <Button
                  type="primary"
                  @click="moveLeft"
                  class="btnLeft "
                ></Button>
                <Button
                  type="primary"
                  @click="moveRight"
                  class="btnRight"
                ></Button>
              </div>
              <div class="changeNum">{{flag+1}}<span>/</span>{{flagLen}}</div>
            </div> 
          </div>
           <div class="bottom">
            <div class="row"><span class="tit">房型介绍：</span>{{parentData.roomIntroduce}}</div>
            <div class="row"><span class="tit">床型：</span> {{parentData.bedType===2?'双人床':'单人床'}}</div>
            <div class="row"><span class="tit">房间设施：</span> 
            <ul class="facility" v-if="parentData.facilities"> 
              <li v-for="(item,idx) in parentData.facilities.split(':')" :key="idx"><i class="icon ishas"></i>{{item}}</li>
              <li class="clearfix"></li>
            </ul>
            </div>
          </div>  
        </div>
    </Modal>
    
</template>

<script>
export default {
  props: {
    ishotelDetail: {
      type: Boolean,
      default: false
    },
    roomsObj: {
      type: Object,
      default: {}
    }
  },

  data () {
    return {
      token: sessionStorage.getItem("name"),
      isadjust: false,
      flag: 0,
      flagLen: 0,
      parentData: {},
      imgList: []
    };
  },
  watch: {
    ishotelDetail (TF) {
      this.isadjust = TF;
    },
    roomsObj (val) {
      this.flag = 0;//当前图片下标
      this.imgList = [];//当前酒店图片
      $('.piclist').animate({ left: `-${this.flag * 280}px` });//当前默认展示第一张
      this.parentData = val;
      //轮播图片
      let roomPicArr = JSON.parse(val.roomPic);
      roomPicArr.map((item, idx) => {
        this.imgList.push({
          upadder: item.response.data.info.url,
          upid: item.response.data.upid
        })
      })
      let len = this.imgList.length;
      //当前多少张图片
      this.flagLen = len;
      //计算装载图片容器宽度
      $('.piclist').css({ width: len * 280 + 'px' })

    }
  },

  methods: {
    onvisiblechange (TF) {
      if (!TF) {
        this.isadjust = TF;
        this.$emit('ishotelDetailfn', this.isadjust)
      }
    },
    moveLeft: function () {
      if (this.flag <= 0) return false;
      this.flag--;
      $('.piclist').animate({ left: `-${this.flag * 280}px` })
    },
    moveRight: function () {
      let width = this.imgList.length - 1;
      if (this.flag >= width) return false;
      this.flag++;
      $('.piclist').animate({ left: `-${this.flag * 280}px` })
    },
  }
};
</script>
<style lang="less" scoped>
.main-container {
  .changeNum {
    margin-top: 7px;
    font-size: 14px;
    color: #323233;
    text-align: center;
  }
  > div {
    width: 545px;
    height: 210px;
    position: relative;
    div.z-ovhid {
      width: 280px;
      height: 210px;
      position: absolute;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      left: 50%;
      -webkit-transform: translatex(-50%);
      transform: translatex(-50%);
      .piclist {
        position: relative;
        > img {
          float: left;
          width: 280px;
          height: 210px;
          cursor: pointer;
        }
      }
    }

    .ivu-btn-primary {
      position: absolute;
      height: 50px;
      width: 25px;
      border: 0;
      outline: none;
      top: 50%;
      transform: translateY(-50%);
    }
    .btnLeft {
      left: 50px;
      background: url("./img/icon_left.svg") no-repeat center;
    }
    .btnRight {
      right: 50px;
      background: url("./img/icon_right.svg") no-repeat center;
    }
  }
}
</style>

 <style lang="less" scoped>
.content {
  background: #fff;
  font-size: 14px;
  min-height: 772px;
  .icon {
    margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 25px;
    // border: 1px solid #eee;
  }
  .ishas {
    background: url("./img/finish-1.svg") no-repeat center;
  }
  // width: 556px;
  .top {
    padding-left: 17px;
    padding-top: 16px;
    height: 327px;
    width: 100%;
    background: #f4f3f0;
    .tit {
      font-size: 21px;
      color: #323233;
    }
    p {
      font-size: 16px;
      color: #4b7ff0;
      margin-bottom: 11px;
    }
  }
  .bottom {
    padding: 20px;
    .row {
      margin-bottom: 15px;
    }
    .tit {
      font-weight: 700;
      font-size: 16px;
      color: #323233;
    }
    .facility {
      // overflow: hidden;
      padding-left: 80px;
      display: inline-block;
      margin-top: -22px;
      li {
        float: left;
        // margin-right: 50px;
        width: 145px;
        margin-bottom: 20px;
      }
      .clearfix {
        display: block;
        content: " ";
        // overflow: hidden;
        clear: both;
      }
    }
  }
}
</style>


